import React from 'react';
import { Box, Flex, Text, Button, IconButton, Separator, Badge, Grid, Card } from '@radix-ui/themes';
import { ReaderIcon, CheckIcon, ExclamationTriangleIcon, DotFilledIcon, PlusIcon } from '@radix-ui/react-icons';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// Import or define these functions if they are not already defined

// Entry point for creating a quiz, flashcards, etc. based on selected topics from lessons
const ScheduleView = ({courses, onCourseSelect, lessonNotes }) => {

    const navigate = useNavigate();
    // const courses = useSelector(state => state.teacherAccount.courses);

    const today = (new Date().getDay() + 6) % 7; // 0-6 for Sunday-Saturday
    const todaysCourses = courses?.filter(course =>
        course.schedules.some(schedule => schedule.day === today)
    );
    const otherCourses = courses?.filter(course =>
        !course.schedules.some(schedule => schedule.day === today)
    );

    const handleSetupCourse = async (course) => {
        navigate(`/teacher/courses/${course.id}`);
    }

    if (courses.length === 0) {
        return (
            <Box>
                <Text size="2" weight="bold" as="p" mb="3">No Courses Found</Text>
                <Text size="1" as="p" mb="3">You dont have any courses registered to your account. Visit your schedule to register a course.</Text>
                <Button onClick={() => navigate('/teacher/schedule')}>Schedule</Button>
            </Box>
        );
    }

    return (
        <Box>
            <Flex direction="column" gap="2">
                {todaysCourses.length === 0 ? (
                    <Box>
                        <Text size="1" as="p" mb="3">It seems you have no courses scheduled for today</Text>
                    </Box>
                ) : (
                    todaysCourses.map(course => (
                        <Box width="100%"
                            key={course.id} p="0"
                        >
                            <Flex direction="row" justify="between" align="center" gap="4">
                                <IconButton variant="soft" color={(lessonNotes && lessonNotes[`notes${course.id}`]) ? "green" : "accent"} size="3" onClick={() => onCourseSelect(course, 'preclass')}><ReaderIcon /></IconButton>
                                <Flex justify="between" align="center" p="2" style={{ flex: 1, cursor: 'pointer', border: 'solid thin var(--gray-7)', borderRadius: 10 }} onClick={() => course.active_teaching_plan ? onCourseSelect(course, 'quiz') : handleSetupCourse(course)}>
                                    <Text size="1" mr="auto">{course.level.label} | {course.subject.name}</Text>
                                    {course.active_teaching_plan ? (
                                        <>
                                            <Badge size="1" color="green" mr="2">Active</Badge>
                                            <Badge size="1">{course.active_teaching_plan.quizzes_count}</Badge>
                                        </>
                                    ) : (
                                        <>
                                            <Badge size="1" color="amber"><ExclamationTriangleIcon />No Active Plan</Badge>
                                        </>
                                    )}
                                </Flex>
                            </Flex>
                        </Box>
                    )))
                }

            </Flex>

            {
                otherCourses.length > 0 && (
                    <Box pt="4">
                        <Separator my="4" size="4" />
                        <Text size="2" weight="bold" as="p" mb="3">Other Courses</Text>
                        <Grid style={{ gridTemplateColumns: 'repeat(2, minmax(100px, 1fr))' }} gap="4">
                            {otherCourses.map(course => (
                                <Card key={course.id} variant="ghost" className="cursor-pointer" onClick={() => course.active_teaching_plan ? handleCourseSelect(course) : handleSetupCourse(course)}>
                                    <Flex direction="row" justify="start" gap="2">
                                        {course.active_teaching_plan ? (<CheckIcon />) : (<ExclamationTriangleIcon />)}
                                        <Text size="1">{course.level.label} | {course.subject.name}</Text>
                                    </Flex>
                                </Card>
                            ))}
                        </Grid>
                    </Box>
                )
            }
        </Box>
    );
};

export default ScheduleView;
